import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { EllipsesIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const MessageExpandButton = ({
  isMessageReplyLoading,
  onClick
}) => {
  return isMessageReplyLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {}) : /*#__PURE__*/_jsx(IconButton, {
    marginBlockStart: "400",
    paddingBlockEnd: "50",
    placement: "top",
    use: "link",
    "data-test-id": "selenium-test-marker-message-expand-btn",
    onClick: onClick,
    children: /*#__PURE__*/_jsx(EllipsesIcon, {
      size: "600",
      color: "icon-primary-disabled"
    })
  });
};
MessageExpandButton.displayName = 'MessageExpandButton';
export default MessageExpandButton;